<template>
  <div v-if="!noResultsState"
       :class="{
       'q-d-block': canShowFiltersOnMobile,
       'q-d-none': !canShowFiltersOnMobile,
       'serp__filters--mobile q-position-fixed q-top-0 q-left-0 q-bottom-0 q-right-0 q-w-100 q-h-100  q-d-none q-md-block': canShowFiltersOnMobile && isMobileView
       }"
       class="serp__filters-container filters-container-top q-container-xxl q-pt-lg-3 q-d-flex q-col-12 q-d-md-block q-py-3 q-py-md-1 q-position-relative ">

    <ComponentLoader v-if="canShowFiltersOnMobile && isMobileView" :loading="isLoading"/>
    <CloseButton/>
    <FiltersHeaderContainer v-if="canShowFiltersOnMobile && isMobileView"/>
    <FiltersDropdownsList/>
  </div>
</template>

<script setup lang="ts">
import {onMounted, onUnmounted, watch} from "vue";
import FiltersDropdownsList from '@/components/SerpPage/FiltersContainer/FiltersList/FiltersDropdownsList.vue'
import FiltersHeaderContainer from '@/components/SerpPage/FiltersContainer/Header/FiltersHeaderContainer.vue'
import CloseButton from "@/components/SerpPage/FiltersContainer/Header/CloseButton.vue";
import ComponentLoader from '@/components/ComponentLoader.vue'


import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import {storeToRefs} from "pinia";
import {useMobileViewStore} from "@/store/MobileViewStore";
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const filtersStore = useFiltersStore();
const mobileViewStore = useMobileViewStore();
const {canShowFiltersOnMobile, isLoading} = storeToRefs(filtersStore)
const {isMobileView, isTabletView} = storeToRefs(mobileViewStore)
const serpStore = useSerpResultsStore();
const {noResultsState} = storeToRefs(serpStore)


watch(canShowFiltersOnMobile, (newValue) => {
  filtersStore.setBodyScroll(!newValue);
});

onMounted(() => {
  filtersStore.fetchFilters();
  window.addEventListener('popstate', () => {
    filtersStore.fetchFilters();
  });
});

onUnmounted(() => {
  window.removeEventListener('popstate', () => {
    filtersStore.fetchFilters();
  });
});

</script>

<style scoped>
.serp__filters-container {
  position: relative;
}

.serp__filters--mobile {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  background-color: white;
  overflow-y: scroll;
}

</style>
